import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { getListRows, getTotalPages } from '@/shared/lib/pagination';
import { fetchNotificationCategories } from '../notifications/api';
import { fetchUserNotifications } from './api';
import { PagedBox } from './PagedBox';

interface NotificationRow extends Record<string, unknown> {
  id: number;
  category_id?: number;
  message?: string;
  create_time?: number;
  read_time?: number | null;
}

export const UserNotificationsBox = ({ userId }: { userId: string | number }) => {
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useQuery({
    queryKey: ['user', String(userId), 'notifications', page],
    queryFn: () => fetchUserNotifications(userId, page),
  });
  const categories = useQuery({ queryKey: ['notification-categories'], queryFn: fetchNotificationCategories });
  const rows = getListRows<NotificationRow>(data, ['notifications']);
  const categoryNames = new Map((categories.data ?? []).map((c) => [c.id, c.description]));

  return (
    <PagedBox
      title="Список уведомлений"
      isLoading={isLoading}
      error={error}
      page={page}
      totalPages={getTotalPages(data)}
      onPageChange={setPage}
    >
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Категория уведомления</th>
            <th>Текст уведомления</th>
            <th>Время отправки уведомления</th>
            <th>Время прочтения уведомления</th>
            <th>Индикатор прочтения уведомления</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>{categoryNames.get(Number(row.category_id))}</td>
              <td>{row.message}</td>
              <td>{formatUnixDateTime(row.create_time)}</td>
              <td>{row.read_time ? formatUnixDateTime(row.read_time) : '-'}</td>
              <td>{row.read_time ? 'Прочитано' : 'Не прочитано'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </PagedBox>
  );
};
